import { HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLDivElement>;

const ButtonContent = (props: Props) => {
    return <div {...props} />;
};

export { ButtonContent };
export type { Props as ButtonContentProps };
